import { useMemo } from "react";
import { trackClubImportNudge, trackClubImportNudgeAction, } from "../analytics/events";
import { useDialogExitTracking, } from "./useDialogExitTracking";
const SHARED_PORT_TRACKERS = {
    onShown: trackClubImportNudge,
    onExit: trackClubImportNudgeAction,
};
/**
 * Shown-and-exit tracking for the club-import nudges.
 *
 * Its own funnel, not the credit one: see the note above the events in
 * analytics/events.ts. Same latch as the gates, so "an exit" means the same
 * thing in both.
 *
 * `section` / `subsection` are the nudge's origin — the surface the pitch was
 * raised on — which is also what `club_import_cta` carries, so a nudge's shows,
 * its accepts and the import that follows all join on the same pair.
 */
export const useClubImportNudgeTracking = (nudgeId, origin, trackers = SHARED_PORT_TRACKERS) => {
    const { section, subsection } = origin;
    const params = useMemo(() => ({ nudgeId, section, subsection }), [nudgeId, section, subsection]);
    return useDialogExitTracking(params, trackers);
};
//# sourceMappingURL=useClubImportNudgeTracking.js.map